import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';

const ZONAS = [
  { code: 'NORTE', label: 'Norte' },
  { code: 'SUR', label: 'Sur' },
];

export default WithApp(function ModalCuotaZonalPanettone(props) {
  const cuota = props.model;
  const periodo = moment(cuota.valueSearch?.Periodo).format('YYYY-MM');

  const [dataChanging, setDataChanging] = useState([]);

  function handleChange(field, value) {
    setDataChanging((prev) => ({ ...prev, [field]: value }));
  }

  useEffect(() => {
    if (cuota.open) {
      setDataChanging({
        ...(cuota.zona ? { zona: cuota.zona } : {}),
      });
    }
  }, [cuota.open]);

  return (
    <>
      <Modal
        title={`Nueva cuota de zona Panetones`}
        model={cuota}
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/panettone_zones'
        dataForce={{
          zona: dataChanging.zona,
        }}
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={periodo || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={ZONAS}
          getOptionLabel={(item) => item.label}
          renderInput={(params) => (
            <TextField {...params} label="Zona" margin="normal" fullWidth />
          )}
          onChange={(e, item) => { handleChange('zona', item?.code); }}
          value={ZONAS.find((z) => z.code === dataChanging.zona) || null}
          style={{ flexGrow: 1, marginRight: '10px' }}
        />
        <TextField
          label="Cuota (unidades)"
          fullWidth
          type="number"
          name="quota"
          margin="normal"
          defaultValue={!!cuota ? cuota.quota : ''}
          required
        />
      </Modal>
    </>
  );
});
